import React from "react";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
// eslint-disable-next-line import/no-unresolved
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Typography, Grid } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import CalendarMonthIcon from "@material-ui/icons/DateRange";
import { FormatAmount } from "../../../utils/Formatter";
// eslint-disable-next-line no-unused-vars
import styles from "./payment-plan.css";

function parseDate(date) {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  const today = new Date(date);
  return today.toLocaleDateString("en-US", options);
}

const getSuccessRowStyle = status => {
  return status === "ACCEPTED" || status === "PAID" ? "successRowStyle" : "";
};

function paymentPlan({ schedule, currency }) {
  const { items, type, nbInstallments, every, unit } = schedule;
  items.sort((a, b) => new Date(a.date) - new Date(b.date).getTime());

  const paymentPlanText = () => {
    if (type === "INSTALLMENT") {
      return `Payable in ${nbInstallments} installments`;
    }
    return `Recurring every ${every} ${unit}`;
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="accordionStyle"
      >
        <Typography className="accordionMainText">
          <i className="paymentScheduleIcon">
            <CalendarMonthIcon />
          </i>
          Payment Plan
        </Typography>
        <Typography className="accordionSecondText">
          {paymentPlanText()}
        </Typography>
      </AccordionSummary>
      <AccordionDetails style={{ overflow: "auto" }}>
        <Grid item xs={12}>
          <Table sx={{ minWidth: 650 }} aria-label="Payment Plan">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell align="left">Amount</TableCell>
                <TableCell align="left">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map(row => (
                <TableRow
                  key={row.date}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  className={getSuccessRowStyle(row.status)}
                >
                  <TableCell align="left">{parseDate(row.date)}</TableCell>
                  <TableCell align="left">
                    {FormatAmount(row.amount, currency)}
                  </TableCell>
                  <TableCell align="left">
                    {row.status === "ACCEPTED" || row.status === "PAID"
                      ? "PAID"
                      : row.status}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
paymentPlan.propTypes = {
  currency: PropTypes.string.isRequired,
  schedule: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape()),
    type: PropTypes.string.isRequired,
    nbInstallments: PropTypes.number,
    unit: PropTypes.string.isRequired,
    every: PropTypes.number.isRequired
  }).isRequired
};

export default paymentPlan;
